<template>
  <b-modal ref="modal" title="Datos de la Remesa" hide-footer>
    <div class="row">
      <div class="col">
        <input v-model="pay_date" id="order_payment_date" type="date" class="form-control" />
        <label class="wabident-info" for="order_payment_date">Fecha Efectiva de Pago</label>
      </div>
      <div class="col">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id="order_mark_as_paid" v-model="mark_as_paid" />
          <label class="form-check-label" for="order_mark_as_paid">Marcar pagos como realizados</label>
        </div>
      </div>
    </div>
    <div class="row form-group text-center">
      <div class="col">
        <button class="btb btn-wabident" @click="submit">Crear Remesa</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      pay_date: null,
      mark_as_paid: false,
    }
  },
  computed: {
    ...mapGetters(['clinic', 'clinic_config', 'errorwindow'])
  },
  methods: {
    show() {
      this.pay_date = new Date().toISODate();
      this.mark_as_paid = false;
      this.$refs.modal.show();
    },
    submit() {
      let msg = 'Esto generará una Remesa con todos los Recibos SEPA pendientes en el periodo.<br><strong>¿Estás segur@?<strong>';
      this.errorwindow.show('Confirmación', msg, 'Aceptar', 'Cancelar', () => {
        this.$emit('submit', this.pay_date, this.mark_as_paid ? 1 : 0);
        this.$refs.modal.hide();
      });
    }
  }
}
</script>
